import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popup-wrapper" }
const _hoisted_2 = { class: "new-customer-popup" }
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "top-row" }
const _hoisted_5 = { class: "first-name" }
const _hoisted_6 = { class: "last-name" }
const _hoisted_7 = { class: "bottom-row" }
const _hoisted_8 = { class: "email" }
const _hoisted_9 = { class: "phone" }
const _hoisted_10 = { class: "button-container" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "exit-container" }, [
        _createElementVNode("div", {
          class: "close",
          onClick: $setup.closePopup
        }, "x")
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "Create a new Customer", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "first-name-label" }, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "first-name-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.firstName) = $event))
            }, null, 512), [
              [_vModelText, $setup.firstName]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "last-name-label" }, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "last-name-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.lastName) = $event))
            }, null, 512), [
              [_vModelText, $setup.lastName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "email-label" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "email-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.email) = $event))
            }, null, 512), [
              [_vModelText, $setup.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "phone-label" }, "Phone", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "phone-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.phone) = $event))
            }, null, 512), [
              [_vModelText, $setup.phone]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "g-outline create-customer-btn",
          onClick: $setup.createAccount
        }, "Create New Customer"),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.error), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}